import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import DatePicker from "react-datepicker";
import { addYears } from "date-fns";
import { DateContainer, From, StyledButton, CustomDatePickerInput } from "./styles";
import { ModalTitle } from "../../shared/styles";
import { messages } from "./messages";
import { DATE_FORMAT } from "../../shared/constants";

interface Props {
  date: Date;
  handleSubmit: (date: Date) => void;
}

export const TimeRangePicker = ({ date, handleSubmit }: Props) => {
  const [selectedDate, setSelectedDate] = useState<Date>(date);
  return (
    <>
      <ModalTitle>
        <FormattedMessage {...messages.absoluteTimeRange} />
      </ModalTitle>
      <From>
        <FormattedMessage {...messages.from} />
      </From>
      <DateContainer>
        <DatePicker
          selected={selectedDate}
          dateFormat={DATE_FORMAT.VISUAL}
          minDate={new Date()}
          maxDate={addYears(new Date(), 2)}
          onChange={(newDate: Date) => setSelectedDate(newDate)}
          customInput={<CustomDatePickerInput type="text" aria-label="from-date-input" />}
        />
        <StyledButton onClick={() => handleSubmit(selectedDate)}>
          <FormattedMessage {...messages.apply} />
        </StyledButton>
      </DateContainer>
    </>
  );
};